import { MAX_BLIND_MAP_DISTANCE_KM } from './constants';

// Threshold for "correct enough" — used to decide confetti and chip color.
// 80 = guess within ~50 km on a 250 km scale; matches heraldry's binary feel
// while still being achievable for blind-map games.
export const CORRECT_SCORE_THRESHOLD = 80;

const toRadians = value => (value * Math.PI) / 180;

export const calculateDistanceKm = (pointA, pointB) => {
    const earthRadiusKm = 6371;
    const dLat = toRadians(pointB.lat - pointA.lat);
    const dLon = toRadians(pointB.lon - pointA.lon);
    const lat1 = toRadians(pointA.lat);
    const lat2 = toRadians(pointB.lat);

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);

    return earthRadiusKm * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export const calculateBlindMapScore = (distanceKm, maxDistanceKm = MAX_BLIND_MAP_DISTANCE_KM) => {
    if (distanceKm <= 0.03) {
        return 100;
    }
    return Math.max(0, Math.round((1 - Math.min(distanceKm, maxDistanceKm) / maxDistanceKm) * 100));
};

export const formatDistance = distanceKm => {
    if (distanceKm < 1) {
        return `${Math.round(distanceKm * 1000)} m`;
    }
    return `${distanceKm < 10 ? distanceKm.toFixed(1) : Math.round(distanceKm)} km`;
};
